import React from 'react';
import '@components/module-components/POSMap/pos-map.scss';
import {translate} from '@src/helpers';
import {useSelector} from "react-redux";

import {ENV} from "@environments/environment";
import {E_ProcessClaimedStatus} from "@src/types";
import {VerifiedLabelMarkupProps} from "@components/module-components/POSMap/types";

const {AWS_S3_FILE_UPLOAD, API_URL, GG_KEY, URL_WEBAPP} = ENV

const VerifiedLabelMarkup: React.FC<VerifiedLabelMarkupProps> = ({className = "", poz}) => {

  const langData = useSelector((state: any) => state.currentLanguage) as any;

  // <span className={"text-green fw-600 mb-1"}
  // className={"text-green text-nowrap fw-600 mt-1 mb-1"}

  return poz.claimed_status !== E_ProcessClaimedStatus.VERIFIED ? null : (
    <span
      className={"fib-marker-verified-status color-242424 text-nowrap " + className}
      dangerouslySetInnerHTML={{
        __html: poz.scanner
          ? "" + translate(langData.localize, "LABEL.VERIFIED_BY_FIBRETRACE.SCANNER", "", {"0": poz.scanner.name})
          : ""
      }}
    />
  )
}

export default VerifiedLabelMarkup;
